import { makeStyles } from 'tss-react/mui';

const useStylesDatePicker: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  datePickerIcon: {
    color: theme.palette.primary.dark,
  },
  datePickerInputNoUnderline: {
    '& > div::before': {
      borderBottom: 'none !important',
    },
  },
}));

export default useStylesDatePicker;
